"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToast = exports.FullWidthButton = exports.StyledForm = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const themed_button_1 = require("../themed-button");
exports.StyledForm = styled_components_1.default.form `
  margin: ${(props) => props.theme.spacings.small} 0 0 0;
`;
exports.FullWidthButton = (0, styled_components_1.default)(themed_button_1.ThemedButton) `
  width: 100%;
  height: 45px;
  font-size: 16px;
  line-height: 21px;
`;
exports.StyledToast = styled_components_1.default.div `
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px calc(min(50px, 5%));
  position: fixed;
  width: fit-content;
  left: 0;
  right: 0;
  margin: auto;
  top: 50%;
  background: #ffffff;
  border: 1px solid #d5d9d9;
  box-shadow: 0px 4px 8px rgba(15, 17, 17, 0.2);
  border-radius: 12px;
  z-index: 10;
`;
